import { Inject, Injectable, OnInit } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { DataService } from "../dataService/data.service";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { GlobalVariable } from "../app.component";
import * as moment from "moment";
import { DateType, Formats } from "./utils";
@Injectable({
  providedIn: "root",
})
export class CommonService implements OnInit {
  private BASE_URL = GlobalVariable;
  public show_review_page = new BehaviorSubject("NO");
  public is_from_negative_feedback = new BehaviorSubject(null);
  public auto_redirect_page = new BehaviorSubject(null);
  // Set when the WhatsApp flow already captured a positive rating, so the rating
  // step is bypassed and the consumer goes straight to the review platform.
  public skip_feedback_step = new BehaviorSubject(false);
  public commonData = new Subject<any>();
  data: any;

  public newAppointmentData = {
    slug: null,
    headerData: null,
    categoryData: null,
    appointmentType: null,
    themeColor: null,
  };

  constructor(
    private httpService: DataService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService
  ) {}

  ngOnInit() {
    // this.getCommonData('NvcOAd');
  }
  getCommonData(slug: string) {
    this.httpService
      .getRequest({
        customApiUrl: this.BASE_URL.REVIEW_RATING_SLUG + "/" + slug,
      })
      .subscribe((data: any) => {
        if (data.code === 200) {
          // console.log("data", data);
          this.data = data.data;
          this.commonData.next(this.data);
        }
      }, error => {
        this.commonData.next({isApiError: true});
      });
  }

  getAppointmentMetaData() {
    return this.httpService.getRequest({
      customApiUrl: this.BASE_URL.GET_APPOINTMENT_METADATA(
        this.newAppointmentData.slug
      ),
    });
  }

  getTagTeamMembers() {
    return this.httpService.getRequest({
      customApiUrl: this.BASE_URL.GET_TAG_TEAM_MEMBERS(
        this.newAppointmentData.slug
      ),
    });
  }

  getBookingSlots(payloadData) {
    return this.httpService.postRequest({
      customApiUrl: this.BASE_URL.GET_BOOKING_SLOTS(
        this.newAppointmentData.slug
      ),
      data: payloadData,
    });
  }

  bookAppointment(payloadData) {
    return this.httpService.postRequest({
      customApiUrl: this.BASE_URL.BOOK_APPOINTMENT_V3(
        this.newAppointmentData.slug
      ),
      data: payloadData,
    });
  }

  bookEnquiry(payloadData) {
    return this.httpService.postRequest({
      customApiUrl: this.BASE_URL.BOOK_INQUIRY(this.newAppointmentData.slug),
      data: payloadData,
    });
  }

  getBookingDetailsFromId(bookingId) {
    return this.httpService.getRequest({
      customApiUrl: this.BASE_URL.GET_BOOKING_DETAILS(
        this.newAppointmentData.slug,
        bookingId
      ),
    });
  }

  getInquiryDetailsFromId(inquiryId) {
    return this.httpService.getRequest({
      customApiUrl: this.BASE_URL.GET_INQUIRY_DETAILS(
        this.newAppointmentData.slug,
        inquiryId
      ),
    });
  }

  getPublicQRDetails(slugValue) {
    return this.httpService.getRequest({
      customApiUrl: this.BASE_URL.QR_PUBLIC_DETAILS,
      outlet_id: slugValue,
    });
  }

  postCustomerPersonalDetails(payloadData) {
    return this.httpService.postRequest({
      customApiUrl: this.BASE_URL.POST_CUSTOMER_DETAILS,
      data: payloadData,
    });
  }

  getData() {
    this.commonData.next(this.data);
  }
  /**
   * open customer review page
   *
   * @param {*} flag
   * @memberof CommonService
   */
  openCustomerReviewPage(flag, negative = null) {
    this.show_review_page.next(flag);
    this.is_from_negative_feedback.next(negative);
  }

  /**
   * auto redirect page
   *
   * @param {*} flag
   * @memberof CommonService
   */
  autoRedirectPage(flag) {
    this.auto_redirect_page.next(flag);
  }

  private toDate(newDate: DateType) {
    let offset = this.storage.get("offset");
    // let offset: string | number = "+14:00";
    return (
      (offset &&
        new Date(
          moment.utc(newDate).utcOffset(offset).format("YYYY-MM-DDTHH:mm:ss")
        )) ||
      new Date()
    );
  }

  getDate(newDate: DateType = new Date()) {
    return this.onDateFilter(newDate);
  }

  onDateFilter(newDate: DateType = new Date()) {
    let actualDate = this.toDate(newDate);
    return actualDate;
  }

  onDateFormat(newDate: DateType = new Date(), format: Formats = null): string {
    let actualDate = moment(this.toDate(newDate));
    return this.formatDate(format, actualDate);
  }

  formatDate(format: Formats, date: moment.Moment): string {
    return (
      (format && format !== "ago" && date.format(format)) || date.fromNow()
    );
  }

  isMobile() {
    return window.innerWidth < 768;
  }

  deepCloneObject(object) {
    let newData = Object.assign({}, object);
    return newData;
  }

  deepCloneArray(data) {
    let cloned = data.map((x) => Object.assign({}, x));
    return cloned;
  }

  format12HourTime(time) {
    return moment(time, ["HH.mm A"]).format("hh:mm A");
  }

  convertHexToRgb(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
      return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    } else {
      return "rgb(" + r + ", " + g + ", " + b + ")";
    }
  }

  capitalizeString(str: string): string {
    if (str.length === 0) {
      return str; // Return empty string if input is empty
    }

    const words = str.split(" ");
    const capitalizedWords = words.map((word) => {
      const capitalizedWord = word.charAt(0).toUpperCase() + word.slice(1);
      return capitalizedWord;
    });

    return capitalizedWords.join(" ");
  }
}
